/**
 * Fichier envoyé à l'enregistrement d'une case.
 *
 * Le fichier choisi dans une boîte n'est valable que pour le programme dont la
 * liste de médias a été chargée. Le 10/10/2026, une case passée de « Dans les
 * coulisses » à « Les Détonnantes » dans « Modifier la diffusion » a gardé le
 * fichier de « Dans les coulisses » et l'a diffusé sous l'autre titre. On
 * n'envoie donc un fichier que s'il figure dans la liste chargée POUR le
 * programme sélectionné ; sinon rien, et le serveur prend le fichier de la
 * fiche (ou garde celui de la case quand le programme ne change pas).
 *
 * Le serveur refuse de toute façon un fichier d'une autre fiche
 * (`backend/src/lib/item-media-ownership.ts`) : ceci évite à l'opérateur de
 * buter sur ce refus.
 */
export interface LoadedProgramMedia {
  /** Programme dont la liste a été chargée. */
  programId: string
  assetIds:  readonly string[]
}

export function mediaAssetIdToSend(input: {
  programId:    string
  mediaAssetId: string
  loaded:       LoadedProgramMedia | null
}): string | undefined {
  if (!input.mediaAssetId || !input.loaded) return undefined
  if (input.loaded.programId !== input.programId) return undefined
  return input.loaded.assetIds.includes(input.mediaAssetId) ? input.mediaAssetId : undefined
}
